<template>
  <div class="allibaba-container">
    <ali-slide
      v-if="isAliUsing"
      @ali-slide-done-event="getAliSlideDoneValue"
      class="alli-slide"
      ref="aliSlide"
    ></ali-slide>
    <grecaptcha v-else @locale-change-event="recapt_id_reset"></grecaptcha>
    <!-- <div class="swap-wrapper" v-if="swapvisible">
      <img
        src="../../assets/img/common/swapButton.svg"
        class="swapButton"
        @click="swap"
      />
    </div> -->
  </div>
</template>
<script>
import grecaptcha from "./grecaptcha";
import aliSlide from "./aliSlide";

export default {
  components: {
    grecaptcha,
    aliSlide,
  },
  props: {
    swapvisible: {
      default: true,
    },
  },
  computed: {
    locale() {
      switch (this.$i18n.locale) {
        case "ko":
          return "ko";
        case "ch":
          return "ch";
        case "en":
          return "en";
        default:
          return "ko";
      }
    },
  },
  data() {
    return {
      isAliUsing: true,
      rcapt_id: null,
      ali_response: null,
    };
  },
  methods: {
    swap() {
      this.isAliUsing = !this.isAliUsing;
      if (this.isAliUsing) {
        this.rcapt_id = null;
        this.$emit("send-response-data-event", this.rcapt_id);
      }
    },
    getResponseData() {
      let result;
      if (this.isAliUsing) {
        result = window.getNVCVal();
      } else {
        result = window.grecaptcha.getResponse(this.rcapt_id);
      }
    },
    sendResponseData() {
      let result;
      if (this.isAliUsing) {
        result = window.getNVCVal();
      } else {
        result = window.grecaptcha.getResponse(this.rcapt_id);
      }
    },
    recapt_id_reset(rcapt_id) {
      this.rcapt_id = rcapt_id;
      this.$emit("send-response-data-event", this.rcapt_id);
    },
    getAliSlideDoneValue(ali_response) {
      this.$emit("send-response-data-event", ali_response);
    },
    aliSlideReset() {
      if (this.isAliUsing) this.$refs.aliSlide.aliSlideReset();
    },
  },
};
</script>
<style lang="scss" scoped>
.allibaba-container {
  display: flex;
  justify-content: center;
  .swap-wrapper {
    position: relative;
    width: 34px;
    height: 34px;
    margin-left: 10px;
    opacity: 0.8;
    border: solid 1px #e6e6e6;
    border-radius: 5px;
    &:hover {
      cursor: pointer;
      background-color: #f6f6f6;
    }
    img.swapButton {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 18px;
    }
  }
}
</style>
